import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from './store/configureStore';
import { startSetExpense } from './actions/expenses';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import $ from 'jquery';
import Popper from 'popper.js';
import 'normalize.css';
import './styles/styles.scss';
import { auth } from './firebase/firebase';
import { login, logout } from './actions/auth';
import AppRouter from './routers/AppRouter';
import LoaderIndicator from './components/LoaderIndicator';

const store = configureStore();

// store.subscribe(() => {
//     console.log(store.getState());
// });

const jsx = ( 
    <Provider store={store}> 
        <AppRouter /> 
    </Provider>
);

ReactDOM.render(<LoaderIndicator />,document.getElementById('root'));

let hasRendered=false;
const render = () => {
    if (!hasRendered) {
        ReactDOM.render(
            jsx,
            document.getElementById('root')
        );

        hasRendered=true;
    }
}

auth.onAuthStateChanged((user)=>{
    if (user) {
        // console.log("login",user);

        store.dispatch(login({uid:user.uid, email:user.email, displayName:user.displayName, photoUrl:user.photoURL}));

        store.dispatch(startSetExpense()).then(()=>{
            render();
        });

    } else {
        console.log("logout");

        store.dispatch(logout());
        render();
    }
});

